var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form" }, [
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-value",
            attrs: { title: _vm.shopDeviceImpRec.fileName }
          },
          [_c("span", [_vm._v(_vm._s(_vm.shopDeviceImpRec.fileName))])]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(1),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDeviceImpRec.importerName))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [
            _vm._v(
              _vm._s(
                _vm.devcVoucherTypeEnumMap[_vm.shopDeviceImpRec.srcVoucherType]
              )
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(3),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDeviceImpRec.srcVoucherNo))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", [_vm._v(_vm._s(_vm.shopDeviceImpRec.importTime))])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(5),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _c("span", { staticStyle: { color: "green" } }, [
            _vm._v(_vm._s(_vm.shopDeviceImpRec.okCount))
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group center" }, [
        _vm._m(6),
        _vm._v(" "),
        _c("div", { staticClass: "form-value" }, [
          _vm.shopDeviceImpRec.errorCount != 0
            ? _c("span", { staticStyle: { color: "red" } }, [
                _vm._v(_vm._s(_vm.shopDeviceImpRec.errorCount))
              ])
            : _c("span", [_vm._v(_vm._s(_vm.shopDeviceImpRec.errorCount))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "table-layout",
        staticStyle: { "overflow-x": "auto", height: "580px" }
      },
      [
        _c("table", { staticClass: "custom-tbl" }, [
          _vm._m(7),
          _vm._v(" "),
          _c(
            "tbody",
            { staticClass: "body" },
            _vm._l(_vm.shopStuffImpItemList, function(shopStuffImpItem) {
              return _c("tr", { staticClass: "row" }, [
                _c(
                  "td",
                  {
                    staticClass: "align-right",
                    staticStyle: { "padding-right": "8px", color: "#999" }
                  },
                  [_vm._v(_vm._s(shopStuffImpItem.rowNo))]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.batchNo))
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("span", { staticStyle: { "font-size": "20px" } }, [
                    _vm._v(_vm._s(shopStuffImpItem.devcDefId != -1 ? "√" : ""))
                  ])
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.innerNo))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.upn))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.stuffName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.shopName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.catName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.brandName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.modelSpec))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  {
                    staticClass: "align-right",
                    staticStyle: { "padding-right": "8px" }
                  },
                  [_vm._v(_vm._s(shopStuffImpItem.quantity))]
                ),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.theUnit))
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm._v(
                    _vm._s(_vm.acctEnterWayMap[shopStuffImpItem.acctEnterWay])
                  )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.departName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.principalName))
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.memo))
                ]),
                _vm._v(" "),
                _c("td", [
                  shopStuffImpItem.failed
                    ? _c(
                        "span",
                        { staticStyle: { color: "red", "font-size": "20px" } },
                        [_vm._v("×")]
                      )
                    : _c(
                        "span",
                        {
                          staticStyle: { color: "green", "font-size": "20px" }
                        },
                        [_vm._v("√")]
                      )
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "align-left" }, [
                  _vm._v(_vm._s(shopStuffImpItem.failDesc))
                ])
              ])
            })
          )
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "pagination-layout" },
      [
        _vm.totalCount > 0
          ? _c("el-pagination", {
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "prev, pager, next, jumper, sizes, total"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("源文件名")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("导入人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据类型")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("来源单据编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("导入时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("成功条数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("失败条数")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c(
          "th",
          {
            staticClass: "align-right",
            staticStyle: { "padding-right": "8px" },
            attrs: { width: "70" }
          },
          [_vm._v("源件行号")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("批次号")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "60" } }, [_vm._v("关联定义")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("外部系统编号")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("统一商品代码(UPC)")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "250" } }, [
          _vm._v("耗材名称")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "250" } }, [
          _vm._v("所属机构")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "140" } }, [
          _vm._v("分类")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "140" } }, [
          _vm._v("品牌")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "250" } }, [
          _vm._v("规格")
        ]),
        _vm._v(" "),
        _c(
          "th",
          {
            staticClass: "align-right",
            staticStyle: { "padding-right": "8px" },
            attrs: { width: "50" }
          },
          [_vm._v("数量")]
        ),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("单位")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "70" } }, [_vm._v("入账方式")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "70" } }, [
          _vm._v("责任部门")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "70" } }, [
          _vm._v("责任人")
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("备注")
        ]),
        _vm._v(" "),
        _c("th", { attrs: { width: "60" } }, [_vm._v("结果")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-left", attrs: { width: "100" } }, [
          _vm._v("失败描述")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-528b0635", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-528b0635","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/ShopDeviceLowCost/ShopDeviceImpItemLowCostList.vue
// module id = 3027
// module chunks = 0